import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class GetInTouch extends React.Component{

    constructor(){
        super();

        
        this.state = { 
            page_content:[],
            loading : 1,
            settings:{},
            email:'', 
            errors:{},
            fopen:false,
            success_message:'',
            reg_error:false,
            err_message:"",
            sending:false
        }
        

    }

    
    handleSubmit = (event) => {
        event.preventDefault();
        const errors = {};
          
        if (!this.state.email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.state.email)) {
          errors.email = 'Invalid email';
        }
         
        if (Object.keys(errors).length > 0) {
          this.setState({ errors });
        } else {
            this.setState({sending:true});
             
            var data = { 'email' :this.state.email }
            axios.post(api_base_url+"send_contact", data).then(response=>{

                if(response.data.error)
                {
                    this.setState({reg_error:true});
                    this.setState({fopen:false});
                    this.setState({err_message: response.data.message });  
                }
                else{
                    errors.email = '';
                    this.setState({ errors });
                    this.setState({fopen:true});
                    this.setState({reg_error:false});
                    this.setState({success_message:" Successfully Subscribed to Our Newsletter."});
                    this.setState({email:'' , sending:false, err_message :""});
                    
                }
                
            }).catch((error) => { 
                  console.log('Conflict error:', error.response);
               
            });

        }
      };
    
    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
      };

    componentDidMount()
    {
        if(JSON.parse(localStorage.getItem("settings")))
        {
            this.setState({settings:JSON.parse(localStorage.getItem("settings"))}) ;
            this.setState({loading:0})
        }
        else{
            axios.get(api_base_url+"settings").then(response=>{
                this.setState({settings:response.data}) ;
            });
        }
        if(JSON.parse(localStorage.getItem("page_content")))
        {
            this.setState({page_content:JSON.parse(localStorage.getItem("page_content"))}) ;
        }
        else
        {
            axios.get(api_base_url+"page_content").then(response=>{
                this.setState({page_content:response.data}); 
                this.setState({loading:0})
            }); 
        }
        
    }


    render()
    { 
        const banner = base_url+'assets/_nuxt/img/bg-blue.8ba217c.jpg';
        
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    return (

        
         <section class="cta-contact" data-v-04dacf6c="" style={{backgroundImage:'url('+banner+')'}}  >
        <section class="section-padded cta-contact-container" data-v-04dacf6c="">
         <div class="cta-contant-content" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500" data-v-04dacf6c="">
          <h2 data-v-04dacf6c="">
           WE ARE READY TO HEAR FROM YOU
          </h2>
          <h1 data-v-04dacf6c="">
           GET IN TOUCH
          </h1>
          <p data-v-04dacf6c="">
           Start a project with ESCO: Define your goals, Identify your team
        members, Establish your work scope, Develop your plan or Let us take
        on your requirements in order to create actionable, systematic and
        logical planning.
          </p>
          <Link class="button-link" data-v-04dacf6c="" to={base_url+`contact-us`} >
           CONTACT US
          </Link>
         </div>
         <div class="cta-contant-content" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500" data-v-04dacf6c="">
          <h1 data-v-04dacf6c="">
           Subscribe
          </h1>
          <p data-v-04dacf6c="">
           Stay up-to-date with ESCO's latest news, and insights of our growth by
        subscribing to our newsletter. Sign up now and be the first to know
        what's happening in our world of energy services.
          </p>
          <form data-v-04dacf6c="">
           <div class="subset" data-v-04dacf6c="">
            <input class="subscribe-text" data-aos="fade-up"  onChange={this.handleChange} value={this.state.email}  data-aos-delay="200" data-aos-duration="500" data-v-04dacf6c="" id="email" name="email" placeholder="johndoe@domain.com" type="email" />
            <div class="subscribe-link" data-v-04dacf6c="">
             <img alt="subscribe-button" class="mail-icon"   onClick={this.handleSubmit} data-aos="fade-left" data-aos-delay="200" data-aos-duration="500" data-v-04dacf6c="" src={base_url+"assets/_nuxt/img/mail.13873c9.svg"}/>
           <div className={this.state.sending ? "dblock" : "dnone"}> <img src={base_url+"assets/images/loader.gif"} className="Loader" alt="Loader" /></div>
                            
            </div>
           </div>
           <span class="alert-error" style={{color:'#f00'}}>{this.state.errors.email && <label className="error">{this.state.errors.email}</label>}</span>
           
           <div data-aos="fade-up" data-aos-delay="200" data-aos-duration="500" data-v-04dacf6c="" fclass="cta-notice">
           
            Please review our
            <Link class="inline-link" data-v-04dacf6c="" to={base_url+`privacy-policy`} >
             Privacy Policy
            </Link>
            to learn about how we use your information
           </div>
          </form>
         </div>
        </section>
       </section>
 
    );
}

}

export default GetInTouch;